import { useTranslation } from "react-i18next";
import styled from "styled-components";
import ManufacturerInfo from "../ManufacturerInfo";
import StatusProduct from "../StatusProduct";

const InforSection = () => {
    const { t, i18n } = useTranslation();
    return (
        <InfoSection>
            <h2 className="text-2xl font-bold mb-4">
                {i18n.language === "vi" ? "Ván ép phủ phim" : "Film-Coated Plywood"}
            </h2>
            <p className="mb-4">
                {i18n.language === "vi" ? (
                    <>
                        <strong>Ván ép phủ phim</strong> - Sản phẩm chất lượng, linh hoạt và đa dạng tính năng
                    </>
                ) : (
                    <>
                        <strong>Film-faced Plywood</strong> - High-qualified, flexible, and diverse in features.
                    </>
                )}
            </p>
            <SpecsTable>
                <tbody>
                    <tr>
                        <SpecTdLabel>{t("measurement")}</SpecTdLabel>
                        <td>1220x2440mm, 910x1820mm,….</td>
                    </tr>
                    <tr>
                        <SpecTdLabel>{t("color")}</SpecTdLabel>
                        <td>
                            {i18n.language === "vi" 
                                ? "Nâu/Đen" 
                                : "Brown/Black"}
                        </td>
                    </tr>
                    <tr>
                        <SpecTdLabel>{t("density")}</SpecTdLabel>
                        <td>
                            600 - 650kgs/m<sup>3</sup>
                        </td>
                    </tr>
                    <tr>
                        <SpecTdLabel>{t("species")}</SpecTdLabel>
                        <td>
                            {i18n.language === "vi" 
                                ? "Gỗ Keo, Bạch đàn (tùy vào đơn hàng)" 
                                : "Acacia, Eucalyptus (depending on order)"}
                        </td>
                    </tr>
                    <tr>
                        <SpecTdLabel>{t("application")}</SpecTdLabel>
                        <td>
                            {i18n.language === "vi" 
                                ? "Cốp-pha xây dựng, đóng tàu, hộp cửa chớp, nội thất,..." 
                                : "Construction formwork, shipbuilding, shutter boxes, furniture,..."}
                        </td>
                    </tr>
                    <tr>
                        <SpecTdLabel>{t("status")}</SpecTdLabel>
                        <td>
                            <StatusProduct />
                        </td>
                    </tr>
                    <tr>
                        <SpecTdLabel>{t("manufacturer")}</SpecTdLabel>
                        <td>
                            <ManufacturerInfo />
                        </td>
                    </tr>
                </tbody>
            </SpecsTable>
        </InfoSection>
    );
};

export default InforSection;

const InfoSection = styled.div`
    flex: 1;
    max-width: 600px;
    width: 100%;
`;

const SpecsTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    margin-top: 16px;

    td {
        border: 1px solid #e1e1e1;
        color: #1c1c1c;
    }
`;

const SpecTdLabel = styled.td`
    font-weight: 600;
    width: 30%;
    min-width: 200px;
    @media (max-width: 768px) {
        width: 40%;
        min-width: 150px;
    }
    background-color: #f8f9fa;
`;